import { Font } from '@ardoq/yfiles';
import { MODERNIZED_BLOCK_DIAGRAM_FONT as FONT } from './consts';
import { canvasLabelMeasurer } from './canvasLabelMeasurer';

export const createMeasurerFromFont = (font: Font) => {
  const fontString = `${font.fontWeight} ${font.fontSize}px ${font.fontFamily}`;
  return canvasLabelMeasurer(fontString);
};

const measureNodeLabel = canvasLabelMeasurer(FONT);

export { measureNodeLabel };
